// extracted by mini-css-extract-plugin
export default {"headerWrapper":"Header_headerWrapper__vnkji","nav":"Header_nav__J8WFt","small":"Header_small__2fR6G","toggle":"Header_toggle__Fdh+y"};